/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationItems_viewer = {
    readonly locationItemsInfo?: ReadonlyArray<{
        readonly locationPage: {
            readonly displayName: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
            readonly items: ReadonlyArray<{
                readonly browseUrl: string | null;
                readonly categoryCode: string | null;
                readonly serviceId: string | null;
                readonly contemporaryTrackingString: string;
                readonly firstPhotoWebPath: string | null;
                readonly linkData: {
                    readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
                };
                readonly seller: {
                    readonly serviceId: string | null;
                } | null;
                readonly title: string | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "HpRespLocationItems_viewer";
};
export type HpRespLocationItems_viewer$data = HpRespLocationItems_viewer;
export type HpRespLocationItems_viewer$key = {
    readonly " $data"?: HpRespLocationItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationItems_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData",
      "args": null
    }
  ]
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespLocationItems_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "locationItemsCount",
      "type": "Int"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "locationItemsInfo",
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "regionTypes",
              "value": "ITEM_LOCATION"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "zipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "locationPage",
              "storageKey": "locationPage(maxWeight:\"METROPOLITAN\",minCount:1,minWeight:\"DISTRICT\",usOnly:true)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "maxWeight",
                  "value": "METROPOLITAN"
                },
                {
                  "kind": "Literal",
                  "name": "minCount",
                  "value": 1
                },
                {
                  "kind": "Literal",
                  "name": "minWeight",
                  "value": "DISTRICT"
                },
                {
                  "kind": "Literal",
                  "name": "usOnly",
                  "value": true
                }
              ],
              "concreteType": "LocationPage",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "items",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "count",
                      "variableName": "locationItemsCount"
                    }
                  ],
                  "concreteType": "Item",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "browseUrl",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryCode",
                      "args": null,
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "contemporaryTrackingString",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "firstPhotoWebPath",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": "master"
                        }
                      ],
                      "storageKey": "firstPhotoWebPath(size:\"master\")"
                    },
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "seller",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Seller",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '175f118b8420d1ca4d5a7297f273758f';
export default node;
